import { createFeatureSelector, createSelector } from '@ngrx/store';
import { loaderFeatureKey, LoaderPartialState } from '../reducers/loader.reducer';
import { MyLoadable } from '@models/my-loadable';

export const getLoaderState = createFeatureSelector<LoaderPartialState, MyLoadable>(
  loaderFeatureKey
);

export const selectLoaderState = createSelector(getLoaderState, state => state);

export const loaderQuery = {
  selectLoaderState
};
